import { Theme, useMediaQuery } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import { Button, DeleteButton, Record, RecordContextProvider, SaveButton, SaveContextProvider, SimpleForm, Toolbar, useNotify, useRefresh } from "react-admin";
import { useForm } from 'react-final-form';
import { useDialogController } from '.';
import { CloseButton, Row, Spacing } from "..";
import { usePreferences } from "@react-admin/ra-preferences";

const Save = ({ saveAction, setRecord }) => {
    const refresh = useRefresh();
    const form = useForm();
    return <SaveButton disabled={!form.getState().dirty} invalid={form.getState().invalid} handleSubmitWithRedirect={async () => {
        const state = form.getState();
        if (state.invalid) {
            form.submit();
        } else {
            if (saveAction) {
                if (await saveAction(form) !== false) {
                    setRecord(null);
                    refresh();
                }
            } else {
                await form.submit();
                refresh();
            }
        }
    }} />;
};

const DialogForm = (props) => {
    const [theme] = usePreferences('theme', 'light');
    const notify = useNotify();
    const refresh = useRefresh();
    const isExtraSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("xs"));
    const { hasDelete, name, resource, record, setRecord, children, saveAction, ...others } = props;
    const handleClose = () => setRecord(null);
    const context = useDialogController({ resource, record, handleClose, name });
    const { defaultTitle, // omit cos use here
        saving, onSuccessRef, setOnSuccess, onFailureRef, setOnFailure, transformRef, setTransform, // omit cos it's inside savinf
        ...contextOmit } = context || {};
    return <Dialog className={theme} open={record !== null} fullWidth fullScreen={isExtraSmall}>
        <SaveContextProvider value={context}>
            <RecordContextProvider<Partial<Record>>
                value={context && context.record}
            >
                <SimpleForm {...contextOmit} {...others} toolbar={<Toolbar>
                    <Save saveAction={saveAction} setRecord={setRecord} />
                    {hasDelete && <DeleteButton mutationMode="pessimistic" redirect={false} onSuccess={() => {
                            handleClose();
                            refresh();
                            notify('ra.notification.deleted', { type: "info", messageArgs: { smart_count: 1 } });
                        }} />
                    }
                    <Spacing />
                    <Button label="resources.cancel" onClick={handleClose}></Button>
                </Toolbar>}>
                    <Row noClone className="stayFlex">
                        <h2>{defaultTitle}</h2>
                        <CloseButton onClick={handleClose} />
                    </Row>
                    {children}
                </SimpleForm>
            </RecordContextProvider>
        </SaveContextProvider>
    </Dialog>
};

export default DialogForm;